import useIsEditing from 'lib/hooks/sitecore/useIsEditing';
import React from 'react';

export function EditingHelpText({
  children,
  className,
  inline,
  hideIf,
  priority,
  componentName,
  ...props
}: React.PropsWithChildren &
  React.HTMLAttributes<HTMLElement> & {
    inline?: boolean;
    hideIf?: boolean;
    priority?: 'warning' | 'normal' | undefined;
    componentName?: string;
  }) {
  const isEditing = useIsEditing();
  if (!isEditing) {
    return <></>;
  }
  if (hideIf) {
    return <></>;
  }

  const classesList = `${className} ${priority === 'warning' ? 'ee-warning-text-block' : 'ee-help-text-block'}`;

  if (inline) {
    return (
      <span className={classesList} {...props}>
        {componentName ? <strong>{componentName}: </strong> : null}
        {children}
      </span>
    );
  }
  return (
    <div className={classesList} {...props}>
      {componentName ? (
        <div>
          <strong>{componentName}</strong>
        </div>
      ) : null}
      {children}
    </div>
  );
}
